import { SCOPELY_ANALYTICS_API_KEY } from "contexts/ScopelyIdentityProvider/constants";

export const SERVICE_WORKER_VERSION =
	process.env.REACT_APP_WEBSTORE_RELEASE_VERSION;
export const SERVICE_WORKER_VERSION_STORAGE_KEY =
	"store.solitairetripeaks.com:serviceWorkerVersion";

export const getServiceWorkerPath = () => {
	const searchParams = new URLSearchParams();

	searchParams.set("apiKey", SCOPELY_ANALYTICS_API_KEY);

	if (SERVICE_WORKER_VERSION) {
		searchParams.set("v", SERVICE_WORKER_VERSION);
	}

	return `/service-worker.js?${searchParams.toString()}`;
};

export const getStoredServiceWorkerVersion = () => {
	try {
		return window.localStorage.getItem(SERVICE_WORKER_VERSION_STORAGE_KEY);
	} catch {
		return null;
	}
};

export const markServiceWorkerVersion = () => {
	if (!SERVICE_WORKER_VERSION) {
		return;
	}

	try {
		window.localStorage.setItem(
			SERVICE_WORKER_VERSION_STORAGE_KEY,
			SERVICE_WORKER_VERSION
		);
	} catch {
		// Storage can be unavailable in restricted browser modes.
	}
};

export const hasExpectedServiceWorkerVersion = (
	serviceWorker: ServiceWorker | null
) => {
	if (!SERVICE_WORKER_VERSION || !serviceWorker?.scriptURL) {
		return false;
	}

	const serviceWorkerUrl = new URL(serviceWorker.scriptURL);
	return serviceWorkerUrl.searchParams.get("v") === SERVICE_WORKER_VERSION;
};
